import React from 'react';
interface EmotionMapProps {
  currentEmotion: string;
  currentSector: string;
  rgbColor: {
    r: number;
    g: number;
    b: number;
  };
  stokesVector: {
    x: number;
    y: number;
    z: number;
  };
}
export const EmotionMap: React.FC<EmotionMapProps> = ({
  currentEmotion,
  currentSector,
  rgbColor,
  stokesVector
}) => {
  const rgbString = `rgb(${Math.round(rgbColor.r * 255)}, ${Math.round(rgbColor.g * 255)}, ${Math.round(rgbColor.b * 255)})`;
  const emotionColorMap = {
    Perception: {
      color: '#00FFFF',
      emotions: ['Calm', 'Shame']
    },
    Novelty: {
      color: '#0000FF',
      emotions: ['Surprise', 'Fear']
    },
    'Goal-plan': {
      color: '#FF00FF',
      emotions: ['Inspiration', 'Stress']
    },
    Action: {
      color: '#FF0000',
      emotions: ['Zeal', 'Rage']
    },
    Progress: {
      color: '#FFFF00',
      emotions: ['Acceptance', 'Disgust']
    },
    Result: {
      color: '#00FF00',
      emotions: ['Joy', 'Sadness']
    }
  };
  return <div className="flex-1 p-4 flex flex-col" data-id="element-57">
      <h2 className="text-xl font-bold mb-4 uppercase" data-id="element-58">EMOTION MAPPING</h2>
      <div className="mb-4 flex items-center" data-id="element-59">
        <div className="w-16 h-16 mr-4 border-2 border-white" style={{
        backgroundColor: rgbString
      }} data-id="element-60"></div>
        <div data-id="element-61">
          <div className="text-2xl font-bold" data-id="element-62">
            {currentEmotion.toUpperCase()}
          </div>
          <div className="text-sm" data-id="element-63">{currentSector} Sector</div>
          <div className="text-xs mt-1" data-id="element-64">
            RGB: {Math.round(rgbColor.r * 255)}, {Math.round(rgbColor.g * 255)},{' '}
            {Math.round(rgbColor.b * 255)}
          </div>
        </div>
      </div>
      <div className="border border-white p-2 mb-4" data-id="element-65">
        <div className="text-sm mb-1" data-id="element-66">STOKES VECTOR:</div>
        <div className="grid grid-cols-3 gap-2 text-center" data-id="element-67">
          <div className="border border-white p-1" data-id="element-68">
            <div className="text-xs" data-id="element-69">X</div>
            <div data-id="element-70">{stokesVector.x.toFixed(2)}</div>
          </div>
          <div className="border border-white p-1" data-id="element-71">
            <div className="text-xs" data-id="element-72">Y</div>
            <div data-id="element-73">{stokesVector.y.toFixed(2)}</div>
          </div>
          <div className="border border-white p-1" data-id="element-74">
            <div className="text-xs" data-id="element-75">Z</div>
            <div data-id="element-76">{stokesVector.z.toFixed(2)}</div>
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-auto border border-white" data-id="element-77">
        <table className="w-full text-left" data-id="element-78">
          <thead data-id="element-79">
            <tr className="border-b border-white" data-id="element-80">
              <th className="p-2" data-id="element-81">SECTOR</th>
              <th className="p-2" data-id="element-82">COLOR</th>
              <th className="p-2" data-id="element-83">EMOTIONS</th>
            </tr>
          </thead>
          <tbody data-id="element-84">
            {Object.entries(emotionColorMap).map(([sector, data]) => <tr key={sector} className={`border-b border-white ${currentSector === sector ? 'bg-white bg-opacity-20' : ''}`} data-id="element-85">
                <td className="p-2 text-xs" data-id="element-86">{sector}</td>
                <td className="p-2" data-id="element-87">
                  <div className="w-6 h-6 border border-white" style={{
                backgroundColor: data.color
              }} data-id="element-88"></div>
                </td>
                <td className="p-2 text-xs" data-id="element-89">
                  <div data-id="element-90">{data.emotions[0]} (+)</div>
                  <div data-id="element-91">{data.emotions[1]} (-)</div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
};